<template>
  <div class="holder">
      <h2 id="page-header"><router-link to="/">My Arlington - Projects</router-link></h2>
      <div class="layer-page">
        <div class="widget">
          <div v-if="project">
            <h3 v-html="'Building Permits for ' + project.title"></h3>
            <br/>
            <table>
              <tbody>
                <tr>
                  <td>Permit #</td>
                  <td>Address</td>
                  <td>Type</td>
                  <td>Status</td>
                  <td>Permit Holder</td>
                  <td>Owner</td>
                  <td>Applied Date</td>
                  <td>Approved Date</td>
                  <td>Date Issued</td>
                  <td>Description</td>
                </tr>
                <tr v-for="permit in permits" :key="permit.permitKey">
                  <td><a target="_blank" :href="'https://permits.arlingtonva.us/Permit_Status.aspx?p_number=' + permit.permitNbr">{{permit.permitNbr}}</a></td>
                  <td>{{permit.streetAddressText}}</td>
                  <td>{{permit.permitTypeCode}}</td>
                  <td>{{permit.permitStatusCode}}</td>
                  <td>{{permit.permitHolderName}}</td>
                  <td>{{permit.propertyOwnerName}}</td>
                  <td>{{permit.appliedDate | defaultDate}}</td>
                  <td>{{permit.approveDate | defaultDate}}</td>
                  <td>{{permit.issuedDate | defaultDate}}</td>
                  <td>{{permit.permitDescriptionText}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import geolib from 'geolib';
import moment from 'moment';
import projectsService from './projects.service';

export default {
  data () {
    return {
      title: 'Test',
      id: this.$route.params.id,
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      zoomLevel: 15,
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        fillColor: '#0040FF',
        fillOpacity: 0.35
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedAssociation: {},
      showCivicAssociations: false,
      permits: []
    }
  },
  computed: {
    ...mapGetters(['projects', 'civicAssociations']),
    project () {
      const project = this.projects.find(f => f.id.toString() === this.id.toString());
      return project;
    },
    mapCenter () {
      if (this.project.shapes !== undefined && this.project.shapes['0']) {
        const shape = this.project.shapes['0'];
        if (shape.shape !== 'marker') {
          const c = geolib.getCenter(shape.coordinates);
          return { lat: Number(c.latitude), lng: Number(c.longitude) };
        } else {
          return shape.coordinates;
        }
      }
      return this.center;
    }
  },
  methods: {
    ...mapActions(['loadProjects', 'loadCivicAssociations']),
    shapeClick (item, clickEvent) {
      this.selectedAssociation = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick () {
      this.selectedAssociation = {};
      this.selectedInfoWindowPosition = null;
    },
    loadPermits () {
      projectsService.loadPermitsForProject(this.project)
        .then(permits => {
          this.permits = permits;
        });
    }
  },
  created () {
    this.loadProjects();
    this.loadCivicAssociations();
  },
  mounted () {
    this.loadPermits();
  },
  watch: {
    project () {
      if (!this.project) {
        return [];
      } else {
        this.loadPermits();
      }
    }
  },
  filters: {
    defaultDate: function (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  }
}
</script>

<style>
  #wp-about *, #wp-process * {
    font-size: 14px;
  }

@media (max-width: 900px)   {

	/* Force table to not be like tables anymore */
	table, thead, tbody, th, td, tr {
		display: block;
	}

	/* Hide table headers (but not display: none;, for accessibility) */
	tr:nth-of-type(1) {
		position: absolute;
		top: -9999px;
		left: -9999px;
	}

	tr {
    border: 1px solid #ccc;
  }

	td {
		/* Behave  like a "row" */
		border: none;
		border-bottom: 1px solid #eee;
		position: relative;
		padding-left: 120px;
    min-height: 24px;
	}

	td:before {
		/* Now like a table header */
		position: absolute;
		/* Top/left values mimic padding */
		left: 6px;
		width: 45%;
		padding-right: 10px;
		white-space: nowrap;
	}

  td:nth-of-type(1):before { content: "Permit #"; }
	td:nth-of-type(2):before { content: "Address"; }
	td:nth-of-type(3):before { content: "Type"; }
	td:nth-of-type(4):before { content: "Status"; }
	td:nth-of-type(5):before { content: "Permit Holder"; }
	td:nth-of-type(6):before { content: "Owner"; }
	td:nth-of-type(7):before { content: "Applied Date"; }
	td:nth-of-type(8):before { content: "Approve Date"; }
	td:nth-of-type(9):before { content: "Issued Date"; }
	td:nth-of-type(10):before { content: "Description"; }
}
</style>



// WEBPACK FOOTER //
// Project.vue?152da578